import React from "react";
import ReactDOM from "react-dom/client";

import { App } from "./App";
import "./index.css";
import "uplot/dist/uPlot.min.css";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
